"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var React = _interopRequireWildcard(require("react"));

var _reduxForm = require("redux-form");

var _rules = require("../../validation/rules");

var _HeightSelect = _interopRequireDefault(require("./HeightSelect/HeightSelect"));

var _WeightSelect = _interopRequireDefault(require("./WeightSelect/WeightSelect"));

var _FieldInfo = _interopRequireDefault(require("../../form/FieldInfo"));

var _gaPushToDataLayer = _interopRequireDefault(require("../../utils/gaPushToDataLayer"));

var _heightWeightConfig = require("./heightWeightConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var HeightWeightDefinition = _flowRuntime["default"].tdz(function () {
  return _heightWeightConfig.HeightWeightDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("error", _flowRuntime["default"].object()), _flowRuntime["default"].property("heightWeight", _flowRuntime["default"].ref(HeightWeightDefinition))));

var HeightWeightFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HeightWeightFields, _React$Component);

  var _super = (0, _createSuper2["default"])(HeightWeightFields);

  function HeightWeightFields() {
    (0, _classCallCheck2["default"])(this, HeightWeightFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _super.call.apply(_super, [this].concat(args));
  }

  (0, _createClass2["default"])(HeightWeightFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var heightWeight = this.props.heightWeight;
      (0, _gaPushToDataLayer["default"])("".concat(window.location.pathname, "-").concat(heightWeight.key), heightWeight.label || heightWeight.key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heightWeight = _this$props.heightWeight,
          componentKey = _this$props.componentKey,
          error = _this$props.error;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: error ? 'hidden' : undefined
      }, /*#__PURE__*/React.createElement(_reduxForm.Field, {
        component: _HeightSelect["default"],
        parentKey: componentKey,
        height: _heightWeightConfig.heightComponent,
        key: _heightWeightConfig.heightField.key,
        name: _heightWeightConfig.heightField.key,
        type: "text",
        validate: (0, _rules.getFieldValidationRules)(_heightWeightConfig.heightField)
      }), /*#__PURE__*/React.createElement(_reduxForm.Field, {
        component: _WeightSelect["default"],
        parentKey: componentKey,
        key: _heightWeightConfig.weightField.key,
        name: _heightWeightConfig.weightField.key,
        type: "text",
        validate: (0, _rules.getFieldValidationRules)(_heightWeightConfig.weightField),
        weight: _heightWeightConfig.weightComponent
      }), heightWeight.info && /*#__PURE__*/React.createElement(_FieldInfo["default"], {
        className: heightWeight.key,
        info: heightWeight.info
      })), error && /*#__PURE__*/React.createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: error
        }
      }));
    }
  }]);
  return HeightWeightFields;
}(React.Component);

exports["default"] = HeightWeightFields;